import { useTranslation } from "react-i18next";

export const useUndefinedIfTranslationMissing = (translationKey: string) => {
  const { t, i18n } = useTranslation();
  return i18n.exists(translationKey) ? t(translationKey) : undefined;
}